/**
 * Configuration constants for text scaling in translated content.
 * These values control how aggressively text is scaled down to fit within original bounds.
 */
export const TEXT_SCALING_CONFIG = {
  /**
   * Minimum font size in pixels. Text will not be scaled below this value
   * to maintain readability.
   */
  MIN_FONT_SIZE: 8,

  /**
   * Scale factor applied per iteration (0.9 = reduce by 10% each time).
   * Lower values = more aggressive scaling, higher values = more gradual scaling.
   */
  SCALE_FACTOR: 0.9,

  /**
   * Maximum number of scaling iterations to prevent infinite loops
   * in case of unexpected edge cases.
   */
  SCALE_ITERATION_LIMIT: 50,
} as const;
